import { useEffect, useState } from "react";
import { destroyCookie, parseCookies } from "nookies";
import { upgradeSession } from "../api/session";
import { logError } from "../logging/logSentryError";
import { COOKIE_TOKEN_PATH, CookieKeys } from "../types/cookie-keys";
import { toError } from "../utils/toError";
import { setSessionCookie } from "../utils/session";

let upgradeStarted = false;

/**
 * Moves a user holding an old login token over to a session token, once per page load.
 * On failure the old token keeps working and the next load retries.
 * Success re-renders the caller so it reads the new cookie.
 */
export function useSessionUpgrade() {
    const [, setUpgraded] = useState(false);

    useEffect(() => {
        if (upgradeStarted) return;

        const cookies = parseCookies();
        const oldToken = cookies[CookieKeys.auth_token];
        if (!oldToken || cookies[CookieKeys.session]) return;

        upgradeStarted = true;

        upgradeSession(oldToken)
            .then(({ authToken }) => {
                setSessionCookie(null, authToken);
                destroyCookie(null, CookieKeys.auth_token, { path: COOKIE_TOKEN_PATH });
                setUpgraded(true);
            })
            .catch((e: unknown) => {
                logError(toError(e));
            });
    }, []);
}
